export default {
    tzolkin: "Цолькин",
    news: "Новости",
    apps: "Приложения",
    about: "О сайте",
    kin: "Кин",
    signs: ["", "Мировое дерево", "Ветер", "Ночь", "Зерно", "Змей", "Череп", "Олень", "Восход","Вода","Собака", "Мастер", "Лестница", "Тростник", "Ягуар","Орёл", "Гриф", "Землетрясение", "Кремень", "Гроза", "Владыка"],
    signs_to: ["", "в Мировое дерево", "в Ветер", "в Ночь", "в Зерно", "в Змея", "в Череп", "в Оленя", "в Восход","в Воду","в Собаку", "в Мастера", "в Лестницу", "в Тростник", "в Ягуара","в Орла", "в Грифа", "в Землетрясение", "в Кремень", "в Грозу", "во Владыку"],
    phantom: "Фантом",
    phantom_empty: "Фантомов нет",
    longcount: "Дата в виде \"длинного счёта\"",
    back_day: "Предыдущий день",
    next_day: "Следующий день",
    character: "Характер",
    meaning_symbol: "Значение символа",
    connections: "Связи с другими знаками",
    support: "поддерживает",
    control: "контролирует",
    passion: "страсть/испытание",
    friend: "партнёр/друг",
    secret: "тайная сила"
};